exports.nationalityButtons = function nationalityButtons () {
    const $removeCountryFieldButton = $('.remove-country-field');
    const $addAdditionalCountryFieldButton = $('.add-additional-country');

    // Configure 'remove' buttons
    $removeCountryFieldButton.click(function (event) {
        event.preventDefault();
        var wrapper = $(event.currentTarget).closest('.additional-country-form-group');
        var autocompleteId = wrapper.find('input:text').attr('id');
        setAutocompleteEmpty(autocompleteId);
        removeErrorClassesFromAutocomplete(autocompleteId)
        wrapper.addClass("hide");
        updateButtonVisibility();
    });

    // Configure 'add country' button
    $addAdditionalCountryFieldButton.click(function (event) {
        event.preventDefault();
        const firsthidden = getHiddenCountryFields().first();
        firsthidden.parent().append(firsthidden);
        firsthidden.removeClass("hide");
        updateButtonVisibility();
        firsthidden.find('input').focus();
    });

    // Set initial display states
    function hideIfEmptyAndErrorFree(element) {
        const $element = $(element);
        const hasError = !!$element.closest('.additional-country-form-group').find('.govuk-error-message').length;
        if (!$element.val() && !hasError) {
            $element.closest('.additional-country-form-group').addClass("hide");
        }
    }

    $('#added-country-2, #added-country-3')
        .each(function (_, element) {
            return hideIfEmptyAndErrorFree(element)
        });

    updateButtonVisibility();

    function updateButtonVisibility() {
        if (getHiddenCountryFields().length === 0) {
            $addAdditionalCountryFieldButton.hide();
        } else {
            $addAdditionalCountryFieldButton.show();
        }
        if (getVisibleCountryFields().length > 1) {
            $removeCountryFieldButton.show();
        } else {
            $removeCountryFieldButton.hide();
        }
    }

    function getHiddenCountryFields() {
        return $('#different-country-html').find('.additional-country-form-group.hide');
    }

    function getVisibleCountryFields() {
        return $('#different-country-html').find('.additional-country-form-group:not(.hide)');
    }
};

function removeErrorClassesFromAutocomplete(autocompleteId) {
    const $select = $('#' + autocompleteId + '-select');
    if ($select.length) {
        $select.prevAll('.govuk-error-message').first().remove();
        $select.closest('.govuk-form-group').removeClass('govuk-form-group--error');
    }

    const $autocompleteInputWrapper = $('#' + autocompleteId).parent();
    if ($autocompleteInputWrapper.length) {
        $autocompleteInputWrapper.removeClass('govuk-select--error');
    }
}

function setAutocompleteEmpty(autocompleteId) {
    const input = document.getElementById(autocompleteId);
    if (input) input.value = '';
    const selectElt = document.getElementById(autocompleteId + '-select');
    if (selectElt) selectElt.value = '';
}